<div class="parts-request-container" *transloco="let t; prefix: 'parts.request'">
  <!-- filters -->
  <div class="filter-container pb-3 d-flex w-100 justify-content-between gap-2">
    <div class="search-wrapper">
      <app-search
        [placeholder]="t('search.placeholder')"
        [disabled]="isLoading"
        (searchTermUpdated)="onSearchTermUpdate($event)"
        customWidth="480px">
      </app-search>
    </div>

    <div class="filters-wrapper d-flex gap-2">
      <!-- Status Filter -->
      <span ngbDropdown class="filter-dropdown" [autoClose]="true">
        <button
          type="button"
          class="btn category-filter form-control dropdown-toggle filter-input"
          [disabled]="isLoading"
          id="categoryFilterDropdown"
          ngbDropdownToggle>
          <div class="d-flex flex-row justify-content-between align-items-center">
            <span class="align-middle">{{ selectedCategory === 'All' ? t('filters.selectStatus') : getStatusLabel(selectedCategory) }}</span>
            <i class="ph ph-caret-down lh-base"></i>
          </div>
        </button>
        <div ngbDropdownMenu aria-labelledby="categoryFilterDropdown" class="dropdown-menu-custom">
          @for (category of categoryOptions; track $index) {
            <button class="btn btn-outline dropdown-item-custom" ngbDropdownItem (click)="onStatusFilterChange(category)">
              {{ getStatusLabel(category) }}
            </button>
          }
        </div>
      </span>

      <button class="issue-part-btn" [disabled]="selectedWorkOrders.size === 0" (click)="onIssuePart()">{{ t('actions.bulkIssueParts') }}</button>
    </div>
  </div>

  <!-- Table -->
  <div class="table-wrapper">
  @if (isRefreshing) {
    <div class="refresh-overlay">
      <div class="spinner-border" role="status"></div>
    </div>
  }
  <div class="main-table parts-request-overview" #tableContainer (scroll)="onScroll($event)">
    <table class="table">
      <thead>
        <tr>
          <th class="checkbox-col"></th>
          <th class="work-order-number" appSortHeader="workOrderNumber" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.workOrderNumber') }}</th>
          <th class="asset" appSortHeader="asset" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.asset') }}</th>
          <th class="requested-by" appSortHeader="requestedBy" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.requestedBy') }}</th>
          <th class="parts-count" appSortHeader="quantity" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.quantity') }}</th>
          <th class="date" appSortHeader="date" [active]="sortColumn" [direction]="sortDirection" (sort)="onSort($event)">{{ t('table.date') }}</th>
          <th class="statuses">{{ t('table.statuses') }}</th>
          <th class="actions">{{ t('table.actions') }}</th>
        </tr>
      </thead>
      @if (isLoading) {
        <tbody>
          <tr class="loading-state-row">
            <td colspan="8">
              <div class="spinner-container">
                <div class="spinner-border" role="status"></div>
              </div>
            </td>
          </tr>
        </tbody>
      } @else {
        <tbody>
          @if (hasError && displayedRequests.length === 0) {
            <tr class="error-state-row">
              <td colspan="8">
                <div class="table__error">
                  <app-error-state></app-error-state>
                </div>
              </td>
            </tr>
          } @else if (displayedRequests.length > 0) {
            @for (request of displayedRequests; track trackByWorkOrderId($index, request)) {
              <tr (click)="toggleRow(request.workOrderId, $event)" class="clickable-row request-summary-row">
                <td class="checkbox-col">
                  <div
                    class="custom-checkbox"
                    [class.checked]="isWorkOrderSelected(request.workOrderId)"
                    [class.disabled]="!canIssueParts(request)"
                    (click)="canIssueParts(request) && onSelectWorkOrder(request.workOrderId); $event.stopPropagation()">
                  </div>
                </td>
                <td class="work-order-number">
                  <p
                    class="cell-text"
                    [ngbPopover]="getWorkOrderTooltip(request.workOrderNumber)"
                    triggers="mouseenter:mouseleave"
                    placement="auto"
                    popoverClass="cell-text-popover"
                    container="body">
                    {{ request.workOrderNumber }}
                  </p>
                </td>
                <td class="asset">
                  <p
                    class="cell-text"
                    [ngbPopover]="getAssetTooltip(request.asset)"
                    triggers="mouseenter:mouseleave"
                    placement="auto"
                    popoverClass="cell-text-popover"
                    container="body">
                    {{ request.asset }}
                  </p>
                </td>
                <td class="requested-by">
                  <p
                    class="cell-text"
                    [ngbPopover]="getRequestedByTooltip(request.requestedBy)"
                    triggers="mouseenter:mouseleave"
                    placement="auto"
                    popoverClass="cell-text-popover"
                    container="body">
                    {{ request.requestedBy }}
                  </p>
                </td>
                <td class="parts-count">
                  <p>{{ request.quantity }}</p>
                </td>
                <td class="date">
                  <p>{{ request.date | date: 'dd/MM/yyyy' }}</p>
                </td>
                <td class="statuses">
                  <div class="status-badges">
                    <span [class]="'status-badge status-' + getRequestStatusVariant(request)">
                      <span class="status-icon">
                        @switch (getRequestStatusVariant(request)) {
                          @case ('pending') {
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM8.862 9.80467L6 6.94267V2.66667H7.33333V6.39067L9.80467 8.862L8.862 9.80467Z" fill="#4F83D1" />
                            </svg>
                          }
                          @case ('approved') {
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.66667 0C2.99067 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3427 0 6.66667 0ZM5.334 9.60867L2.85867 7.13867L3.8 6.19467L5.33267 7.72467L8.862 4.19533L9.80467 5.138L5.334 9.60867Z" fill="#46A053" />
                            </svg>
                          }
                          @case ('rejected') {
                            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.63533 0C2.97667 0 0 2.99067 0 6.66667C0 10.3427 2.99067 13.3333 6.66667 13.3333C10.3427 13.3333 13.3333 10.3427 13.3333 6.66667C13.3333 2.99067 10.3287 0 6.63533 0ZM7.33333 10H6V8.66667H7.33333V10ZM7.33333 7.33333H6V3.33333H7.33333V7.33333Z" fill="#FF7F00" />
                            </svg>
                          }
                        }
                      </span>
                      <span class="status-text">{{ getRequestStatusText(request) }}</span>
                    </span>
                  </div>
                </td>
                <td class="actions">
                  <div class="summary-actions">
                    <div class="action-state-slot">
                      @switch (getWorkOrderActionState(request)) {
                        @case ('pending') {
                          <button class="action-btn close-btn" (click)="onRemove(request, $event)" [disabled]="isWorkOrderProcessing(request)" [title]="t('actions.rejectAll')">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M10.7946 4.23047L7.96598 7.05847L5.13798 4.23047L4.19531 5.17314L7.02331 8.00114L4.19531 10.8291L5.13798 11.7718L7.96598 8.9438L10.7946 11.7718L11.7373 10.8291L8.90931 8.00114L11.7373 5.17314L10.7946 4.23047Z" fill="#6E6668" />
                            </svg>
                          </button>
                          <button class="action-btn approve-icon-btn" (click)="onApproveAll(request, $event)" [disabled]="isWorkOrderProcessing(request)" [title]="t('actions.approveAll')">
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M6.66925 10.391L4.47392 8.19564L3.53125 9.1383L6.66925 12.2763L13.1406 5.80497L12.1979 4.8623L6.66925 10.391Z" fill="#EE2737" />
                            </svg>
                          </button>
                        }
                        @case ('approved') {
                          <button class="btn-status approved-state" (click)="onResetStatus(request, $event)" [disabled]="isWorkOrderProcessing(request)">
                            @if (isWorkOrderProcessing(request)) {
                              <span class="spinner-border spinner-border-sm"></span>
                            } @else {
                              <span>
                                <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M0.666779 12.378C0.720779 12.378 0.774779 12.3713 0.828112 12.358L3.49478 11.6913C3.61211 11.662 3.71945 11.6013 3.80478 11.516L12.0001 3.32067C12.2521 3.06867 12.3908 2.734 12.3908 2.378C12.3908 2.022 12.2521 1.68733 12.0001 1.43533L10.9428 0.378C10.4388 -0.126 9.56145 -0.126 9.05745 0.378L0.862112 8.57333C0.776779 8.65867 0.716112 8.766 0.686779 8.88267L0.0201122 11.5493C-0.0372211 11.7767 0.0301122 12.0167 0.195446 12.1827C0.321446 12.3093 0.492112 12.378 0.666779 12.378ZM10.0001 1.32067L11.0574 2.378L10.0001 3.43533L8.94278 2.378L10.0001 1.32067ZM1.93545 9.38533L8.00011 3.32067L9.05745 4.378L2.99211 10.4427L1.58278 10.7947L1.93545 9.38533Z" fill="#EE2737"/>
                                </svg>
                              </span>
                              {{ t('status.approved') }}
                            }
                          </button>
                        }
                        @case ('issued') {
                          <button class="btn-status approved-state" (click)="$event.stopPropagation()">
                            <span>
                              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M6.6673 10.391L4.47196 8.19564L3.5293 9.1383L6.6673 12.2763L13.1386 5.80497L12.196 4.8623L6.6673 10.391Z" fill="#EE2737"/>
                              </svg>
                            </span>
                            {{ t('status.issued') }}
                          </button>
                        }
                        @case ('rejected') {
                          <button class="btn-status rejected-state" (click)="onResetStatus(request, $event)" [disabled]="isWorkOrderProcessing(request)">
                            @if (isWorkOrderProcessing(request)) {
                              <span class="spinner-border spinner-border-sm"></span>
                            } @else {
                              <span>
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M2.66873 14.0001C2.72273 14.0001 2.77673 13.9934 2.83007 13.9801L5.49673 13.3134C5.61407 13.2841 5.7214 13.2234 5.80673 13.1381L14.0021 4.94274C14.2541 4.69074 14.3927 4.35607 14.3927 4.00007C14.3927 3.64407 14.2541 3.3094 14.0021 3.0574L12.9447 2.00007C12.4407 1.49607 11.5634 1.49607 11.0594 2.00007L2.86407 10.1954C2.77873 10.2807 2.71807 10.3881 2.68873 10.5047L2.02207 13.1714C1.96473 13.3987 2.03207 13.6387 2.1974 13.8047C2.3234 13.9314 2.49407 14.0001 2.66873 14.0001ZM12.0021 2.94274L13.0594 4.00007L12.0021 5.0574L10.9447 4.00007L12.0021 2.94274ZM3.9374 11.0074L10.0021 4.94274L11.0594 6.00007L4.99407 12.0647L3.58473 12.4167L3.9374 11.0074Z" fill="currentColor"/>
                                </svg>
                              </span>
                              {{ t('status.rejected') }}
                            }
                          </button>
                        }
                      }
                    </div>
                    <button
                      class="action-btn issue-parts-action"
                      [disabled]="!canIssueParts(request)"
                      (click)="onIssuePart(request); $event.stopPropagation()">
                      {{ t('actions.issueParts') }}
                    </button>
                    <button class="action-btn more-btn" (click)="toggleRow(request.workOrderId, $event)" [title]="t('actions.moreActions')">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" [class.rotated]="isRowExpanded(request.workOrderId)">
                        <path d="M10.862 6.19531L7.99998 9.05731L5.13798 6.19531L4.19531 7.13798L7.99998 10.9426L11.8046 7.13798L10.862 6.19531Z" fill="#6B6D71" />
                      </svg>
                    </button>
                  </div>
                </td>
              </tr>

              @if (isRowExpanded(request.workOrderId)) {
                <tr class="expanded-row">
                  <td colspan="8" class="expanded-content">
                    <table class="detail-table">
                      <thead>
                        <tr>
                          <th class="part-number">{{ t('detailTable.partNumber') }}</th>
                          <th class="part-name">{{ t('detailTable.partName') }}</th>
                          <th class="category">{{ t('detailTable.category') }}</th>
                          <th class="available">{{ t('detailTable.quantityAvailable') }}</th>
                          <th class="requested">{{ t('detailTable.quantityRequested') }}</th>
                          <th class="action">{{ t('detailTable.action') }}</th>
                          <th class="notes">{{ t('detailTable.notes') }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        @for (part of request.parts; track trackByPartRequestId($index, part)) {
                          <tr class="parts-table-row">
                            <td class="part-number">
                              <p class="cell-text"
                                [ngbPopover]="getPartNumberTooltip(part.partNumber)"
                                triggers="mouseenter:mouseleave"
                                placement="auto"
                                popoverClass="cell-text-popover"
                                container="body">{{ part.partNumber }}</p>
                            </td>
                            <td class="part-name">
                              <p class="cell-text"
                                [ngbPopover]="getPartNameTooltip(part.partName)"
                                triggers="mouseenter:mouseleave"
                                placement="auto"
                                popoverClass="cell-text-popover"
                                container="body">{{ part.partName }}</p>
                            </td>
                            <td class="category">
                              <p class="cell-text"
                                [ngbPopover]="getCategoryTooltip(part.category)"
                                triggers="mouseenter:mouseleave"
                                placement="auto"
                                popoverClass="cell-text-popover"
                                container="body">{{ part.category }}</p>
                            </td>
                            <td class="available" [class.zero-available]="part.quantityAvailable === 0">{{ part.quantityAvailable }}</td>
                            <td class="requested" [class.highlighted-requested]="part.quantityRequested > part.quantityAvailable">{{ part.quantityRequested }}</td>
                            <td class="action">
                              @switch (getActionState(part)) {
                                @case ('pending') {
                                  <div class="d-flex gap-2 w-100 part-pending-actions">
                                    <button class="btn-reject" (click)="onReject(request, part, $event)" [disabled]="rejectingPartIds.has(part.id)" [title]="t('actions.reject')">
                                      @if (rejectingPartIds.has(part.id)) {
                                        <span class="spinner-border spinner-border-sm"></span>
                                      } @else {
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M10.7946 4.22949L7.96598 7.05749L5.13798 4.22949L4.19531 5.17216L7.02331 8.00016L4.19531 10.8282L5.13798 11.7708L7.96598 8.94283L10.7946 11.7708L11.7373 10.8282L8.90931 8.00016L11.7373 5.17216L10.7946 4.22949Z" fill="#6E6668" />
                                        </svg>
                                      }
                                    </button>
                                    <button class="btn-approve w-70" (click)="onApprove(part, $event)" [disabled]="processingPartIds.has(part.id)" [title]="t('actions.approve')">
                                      @if (processingPartIds.has(part.id)) {
                                        <span class="spinner-border spinner-border-sm"></span>
                                      } @else {
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M6.66925 10.391L4.47392 8.19564L3.53125 9.1383L6.66925 12.2763L13.1406 5.80497L12.1979 4.8623L6.66925 10.391Z" fill="#EE2737" />
                                        </svg>
                                        {{ t('actions.approve') }}
                                      }
                                    </button>
                                  </div>
                                }
                                @case ('approved') {
                                  <button class="btn-status approved-state" (click)="onResetPartStatus(part, $event)" [disabled]="processingPartIds.has(part.id)" [title]="t('status.approved')">
                                    @if (processingPartIds.has(part.id)) {
                                      <span class="spinner-border spinner-border-sm"></span>
                                    } @else {
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.66873 14.0001C2.72273 14.0001 2.77673 13.9934 2.83007 13.9801L5.49673 13.3134C5.61407 13.2841 5.7214 13.2234 5.80673 13.1381L14.0021 4.94274C14.2541 4.69074 14.3927 4.35607 14.3927 4.00007C14.3927 3.64407 14.2541 3.3094 14.0021 3.0574L12.9447 2.00007C12.4407 1.49607 11.5634 1.49607 11.0594 2.00007L2.86407 10.1954C2.77873 10.2807 2.71807 10.3881 2.68873 10.5047L2.02207 13.1714C1.96473 13.3987 2.03207 13.6387 2.1974 13.8047C2.3234 13.9314 2.49407 14.0001 2.66873 14.0001ZM12.0021 2.94274L13.0594 4.00007L12.0021 5.0574L10.9447 4.00007L12.0021 2.94274ZM3.9374 11.0074L10.0021 4.94274L11.0594 6.00007L4.99407 12.0647L3.58473 12.4167L3.9374 11.0074Z" fill="#EE2737"/>
                                      </svg>
                                      {{ t('status.approved') }}
                                    }
                                  </button>
                                }
                                @case ('issued') {
                                  <button class="btn-status approved-state" (click)="$event.stopPropagation()" [title]="t('status.issued')">
                                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M6.6673 10.391L4.47196 8.19564L3.5293 9.1383L6.6673 12.2763L13.1386 5.80497L12.196 4.8623L6.6673 10.391Z" fill="#EE2737"/>
                                    </svg>
                                    {{ t('status.issued') }}
                                  </button>
                                }
                                @case ('rejected') {
                                  <button class="btn-status rejected-state" (click)="onResetPartStatus(part, $event)" [disabled]="processingPartIds.has(part.id)" [title]="t('status.rejected')">
                                    @if (processingPartIds.has(part.id)) {
                                      <span class="spinner-border spinner-border-sm"></span>
                                    } @else {
                                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M2.66873 14.0001C2.72273 14.0001 2.77673 13.9934 2.83007 13.9801L5.49673 13.3134C5.61407 13.2841 5.7214 13.2234 5.80673 13.1381L14.0021 4.94274C14.2541 4.69074 14.3927 4.35607 14.3927 4.00007C14.3927 3.64407 14.2541 3.3094 14.0021 3.0574L12.9447 2.00007C12.4407 1.49607 11.5634 1.49607 11.0594 2.00007L2.86407 10.1954C2.77873 10.2807 2.71807 10.3881 2.68873 10.5047L2.02207 13.1714C1.96473 13.3987 2.03207 13.6387 2.1974 13.8047C2.3234 13.9314 2.49407 14.0001 2.66873 14.0001ZM12.0021 2.94274L13.0594 4.00007L12.0021 5.0574L10.9447 4.00007L12.0021 2.94274ZM3.9374 11.0074L10.0021 4.94274L11.0594 6.00007L4.99407 12.0647L3.58473 12.4167L3.9374 11.0074Z" fill="#4D4749"/>
                                      </svg>
                                      {{ t('status.rejected') }}
                                    }
                                  </button>
                                }
                              }
                            </td>
                            <td class="notes">
                              @if (!part.hasNotes) {
                                <button class="note-btn" (click)="onAddNote(part, $event)" [title]="t('actions.addNote')">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M19 11H13V5H11V11H5V13H11V19H13V13H19V11Z" fill="#9FA1A4" />
                                  </svg>
                                </button>
                              } @else {
                                <button class="note-btn" (click)="onViewDetails(part, $event)" [title]="t('actions.viewDetails')">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 9C10.358 9 9 10.359 9 12C9 13.642 10.358 15 12 15C13.641 15 15 13.642 15 12C15 10.359 13.641 9 12 9Z" fill="#9FA1A4" />
                                    <path d="M11.9993 5C4.36631 5 2.07231 11.617 2.05131 11.684L1.94531 12L2.05031 12.316C2.07231 12.383 4.36631 19 11.9993 19C19.6323 19 21.9263 12.383 21.9473 12.316L22.0533 12L21.9483 11.684C21.9263 11.617 19.6323 5 11.9993 5ZM11.9993 17C6.64831 17 4.57531 13.154 4.07331 12C4.57731 10.842 6.65131 7 11.9993 7C17.3503 7 19.4233 10.846 19.9253 12C19.4213 13.158 17.3473 17 11.9993 17Z" fill="#9FA1A4" />
                                  </svg>
                                </button>
                              }
                            </td>
                          </tr>
                        }
                      </tbody>
                    </table>
                  </td>
                </tr>
              }
            }

            @if (isLoadingMore) {
              <tr class="loading-more-row">
                <td colspan="8" class="text-center">
                  <div class="spinner-border spinner-border-sm" role="status">
                    <span class="visually-hidden">{{ t('loadingMore') }}</span>
                  </div>
                  <span class="ms-2">{{ t('loadingMoreItems') }}</span>
                </td>
              </tr>
            }
          }

          @if (displayedRequests.length === 0 && !isLoading && !hasError) {
            <tr class="empty-state-row">
              <td colspan="8">
                <div class="table__no-data">
                  <app-empty-state></app-empty-state>
                </div>
              </td>
            </tr>
          }
        </tbody>
      }
    </table>
  </div>
  </div>
</div>